import { jsxs, jsx } from "react/jsx-runtime";
import { Box, Text } from "braid-design-system";
import { titleContainer } from "./index.css.mjs";
const TeamMemberInfoRow = ({ title, children }) => /* @__PURE__ */ jsxs(Box, { display: "flex", paddingX: "small", alignItems: "center", children: [
  /* @__PURE__ */ jsx(
    Box,
    {
      flexGrow: 0,
      flexShrink: 0,
      className: titleContainer,
      paddingRight: "small",
      children: /* @__PURE__ */ jsx(Text, { baseline: false, align: "right", weight: "strong", children: title })
    }
  ),
  /* @__PURE__ */ jsx(Box, { flexGrow: 1, style: { minWidth: "0" }, children })
] });
export {
  TeamMemberInfoRow
};
